const routes = {
	path: '/dashboard',
	component: resolve => require ( ['./../customer-views/dashboard/index.vue'], resolve ),
	children: [
		{
			path: '',
			component: resolve => require ( ['./../customer-views/dashboard/entry.vue'], resolve )
		},
		{
			path: 'account',
			component: resolve => require ( ['./../customer-views/dashboard/account/index.vue'], resolve ),
			children: [
				{
					path: '',
					component: resolve => require ( ['./../customer-views/dashboard/account/account-info.vue'], resolve )
				},
				{
					path: 'payment-history',
					component: resolve => require ( ['./../customer-views/dashboard/account/payment-history.vue'], resolve )
				}
			]
		},
		{
			path: 'credits',
			component: resolve => require ( ['./../customer-views/dashboard/credits/index.vue'], resolve ),
			children: [
				{
					path: '',
					component: resolve => require ( ['./../customer-views/dashboard/credits/view-credits.vue'], resolve )
				},
				{
					path: 'purchase',
					component: resolve => require ( ['./../customer-views/dashboard/credits/purchase-credits.vue'], resolve )
				},
				{
					path: 'send-receive',
					component: resolve => require ( ['./../customer-views/dashboard/credits/send-receive-credits.vue'], resolve )
				}
			]
		},
		{
			path: 'bookings',
			component: resolve => require ( ['./../customer-views/dashboard/bookings/index.vue'], resolve ),
			children: [
				{
					path: '',
					component: resolve => require ( ['./../customer-views/dashboard/bookings/bookings.vue'], resolve )
				},
				{
					path: ':bookingID',
					component: resolve => require ( ['./../customer-views/dashboard/bookings/view-booking.vue'], resolve )
				}
			]
		}
	]
};

export default routes;


// WEBPACK FOOTER //
// ./src/custom/routes/customer-routes.js